var React = require('react');

function Archive (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M32 160v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V160zm288 84a12 12 0 0 1-12 12H204a12 12 0 0 1-12-12v-8a12 12 0 0 1 12-12h104a12 12 0 0 1 12 12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M512 64v48a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16V64a32 32 0 0 1 32-32h448a32 32 0 0 1 32 32z","className":"fa-primary","key":2})]);
}

Archive.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Archive;

Archive.default = Archive;
